import { render, staticRenderFns } from "./PrizesEdit.vue?vue&type=template&id=7ebb61c2"
import script from "./PrizesEdit.vue?vue&type=script&lang=js"
export * from "./PrizesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports